import React from "react";
import logo from "../../../assets/kangaroo/kangrooooo.png";
import { Col, Container, Row } from "reactstrap";
import fbIcon from "../../../assets/kangaroo/facebookIcon.png";
import inIcon from "../../../assets/kangaroo/instagramIcon.png";
import tiktokIcon from "../../../assets/kangaroo/tiktokIcon.png";
import linkedinIcon from "../../../assets/kangaroo/linkedinIcon.png";
import twitterIcon from "../../../assets/kangaroo/twitterIcon.png";
import { hover, motion } from "framer-motion";
import "../../../Homepage/Component/Homepage.css";
import { Link } from "react-router-dom";
import PrivacyService from "../../../services/Privacy";
import { useQuery } from "@tanstack/react-query";
import FooterService from "../../../services/FooterService";
import { imageBaseApi } from "../../../services/imageBaseApi";

const Footer = ({ footerMenus }) => {
  const fetchData = async () => {
    const response = await PrivacyService.getList()
    return response?.items
  }

  const { isLoading, error, data } = useQuery({
    queryKey: ["privacy"],
    queryFn: fetchData,
  })

  const fetchFooterData = async () => {
    const response = await FooterService.getList()
    return response
  }


  const { data: footerData } = useQuery({
    queryKey: ["footer"],
    queryFn: fetchFooterData,
  })
  console.log("🚀 ~ Footer ~ footerData:", footerData)

  return (
    <div
      className="main-container py-3 mt-5"
    >
      <Container className="w-100">
        {/* Header Section */}
        {/* <Row className="mb-5 align-items-center">
          <Col xs={12} md={4} className="mb-3 mb-md-0">
            <img
              src={logo}
              alt="KEF Logo"
              className="img-fluid"
              style={{ maxHeight: "106px" }}
            />
          </Col>
          <Col lg={2}></Col>
          <Col
            sm={12}
            md={6}
            className="d-flex justify-content-md-end gap-3"
            style={{ marginBottom: "2.5rem" }}
          >
            {/* CONTACT US Button */}
        {/* <motion.button
              className="rounded-pill border border-white navbar-btn-font"
              style={{
                backgroundColor: "transparent",
                width: "235px",
                height: "45px",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
              }}
              whileHover="hover"
            >
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "#FF6A17",
                  zIndex: 0,
                }}
                initial={{ x: "-100%" }}
                variants={{ hover: { x: 0 } }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              />
              <Link
                to="/contact"
                className="text-decoration-none"
                style={{ cursor: "pointer", color: "white" }}
              >
                <motion.span style={{ position: "relative", zIndex: 1 }}>
                  CONTACT US
                </motion.span>
              </Link>
            </motion.button> */}

        {/* GET FREE COUNSELING Button */}
        {/* <motion.button
              className="rounded-pill navbar-btn-font py-2"
              style={{
                width: "265px",
                height: "45px",
                border: "0px",
                position: "relative",
                background: "#FF6A17",
                overflow: "hidden",
                cursor: "pointer",
              }}
              whileHover="hover"
            >
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "linear-gradient(to right, #83168F, #D40B84)",
                  zIndex: 0,
                }}
                initial={{ x: "-100%" }}
                variants={{ hover: { x: 0 } }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              />
              <Link
                to="/freecounseling"
                className="text-decoration-none"
                style={{ cursor: "pointer", color: "white" }}
              >
                <motion.span style={{ position: "relative", zIndex: 1 }}>
                  GET FREE COUNSELING
                </motion.span>
              </Link>
            </motion.button> */}
        {/* </Col>
        </Row> */}

        {/* Links Section */}
        {/* <Row className="mb-5">
          {footerMenus.map((menu) => (
            <Col key={menu.id} xs={12} sm={6} md={3} className="mb-4 mb-md-0">
              <h5 className="mb-3 navbar-btn-font">{menu.title}</h5>
              {menu.children
                .sort((a, b) => a.orderIndex - b.orderIndex)
                .map((child) =>
                  child.isExternal ? (
                    <a
                      key={child.id}
                      href={child.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mb-2 footer-item-font d-block text-decoration-none"
                      style={{ cursor: "pointer" }}
                    >
                      {child.title}
                    </a>
                  ) : (
                    <Link
                      key={child.id}
                      to={child.url}
                      className="mb-2 footer-item-font d-block text-decoration-none"
                      style={{ cursor: "pointer" }}
                    >
                      {child.title}
                    </Link>
                  )
                )}
            </Col>
          ))}
        </Row> */}

        {/* Divider */}
        {/* <hr className="border border-white mb-4" /> */}

        {/* Social Media Icons */}
        {/* <Row className="mb-4">
          <Col
            xs={12}
            className="d-flex justify-content-center justify-content-md-start gap-3 "
          >
            {footerData
              ?.filter(item => item.isActive && !item.isTextOnly)
              ?.map(item => (
                <div key={item.id} >

                  <a
                    href={item?.facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="me-3"
                  >
                    <img
                      src={imageBaseApi + item?.facebookImage?.url}
                      style={{ width: "38px", height: "38px" }}
                      alt="Facebook"
                    />
                  </a>

                  <a
                    href={item?.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                     className="me-3"
                  >
                    <img
                      src={imageBaseApi + item?.instagramImage?.url}
                      style={{ width: "38px", height: "38px" }}
                      alt="Instagram"
                    />
                  </a>
                  <a
                    href={item?.tikTokUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                     className="me-3"
                  >
                    <img
                      src={imageBaseApi + item?.tikTokImage?.url}
                      style={{ width: "38px", height: "38px" }}
                      alt="TikTok"
                    />
                  </a>

                  <a
                    href={item?.linkedInUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                     className="me-3"
                  >
                    <img
                      src={imageBaseApi + item?.linkedInImage?.url}
                      style={{ width: "38px", height: "38px" }}
                      alt="Linked IN"
                    />
                  </a>
                  <a
                    href={item?.xUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={imageBaseApi + item?.xImage?.url}
                      style={{ width: "38px", height: "38px" }}
                      alt="TikTok"
                    />
                  </a>



                </div>

              ))}


            {/* <a
              href="https://www.facebook.com/KangarooEdu/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={fbIcon}
                style={{ width: "38px", height: "38px" }}
                alt="Facebook"
              />
            </a>

            <a
              href="https://www.instagram.com/kangaroo_education_foundation/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={inIcon}
                style={{ width: "38px", height: "38px" }}
                alt="Instagram"
              />
            </a>

            <a
              href="https://www.tiktok.com/@kangaroo.edu?lang=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={tiktokIcon}
                style={{ width: "38px", height: "38px" }}
                alt="TikTok"
              />
            </a>

            <a
              href="https://np.linkedin.com/company/kangaroo-education-foundation"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedinIcon}
                style={{ width: "38px", height: "38px" }}
                alt="LinkedIn"
              />
            </a>
            <a href="https://x.com/KangarooEdu" target="_blank" rel="noopener noreferrer">
              <img
                src={twitterIcon}
                style={{ width: "38px", height: "38px" }}
                alt=""
              />
            </a> */}
        {/* </Col>
        </Row> */}

        {/* Footer Bottom */}
        <Row className="align-items-center ">
          <Col
            xs={12}
            md={6}
            className="mb-2 mb-md-0 text-center text-md-start"
          >
            <p className="mb-0 text-white " style={{ fontSize: "0.9rem" }}>
              Copyright © 2026 Kangaroo Education Foundation
            </p>
          </Col>
          {/* <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center justify-content-md-end gap-5"
          >

            {data && data?.map((item, index) => (
              <Link to={`/privacy/${item?.slug}`}
                key={index} // always provide a unique key if possible
                className="text-white"
                style={{ fontSize: "14px" }}
              >
                {item?.heading}
              </Link>
            ))}
          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
